<template>
  <div class="data-examine">
    <div class="option-box">
      <div class="btn1">在线：{{ onLine }}个</div>
      <div class="btn2">离线：{{ offLine }}个</div>
    </div>
    <div class="search-box">
      <el-form
        inline
        :model="formInline"
        class="demo-form-inline"
        label-width="120px"
      >
        <el-form-item label="所属乡镇">
          <el-select clearable class="form-select" popper-class="form-select-dropdown" :popper-append-to-body="false" v-model="formInline.town" placeholder="请选择">
            <el-option
              v-for="item in townshipList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input clearable v-model="formInline.deviceName" class="form-input" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="状态" label-width="80px">
          <el-select clearable class="form-select" popper-class="form-select-dropdown" :popper-append-to-body="false" v-model="formInline.status" placeholder="请选择">
            <el-option
              label="在线"
              :value="1">
            </el-option>
            <el-option
              label="离线"
              :value="0">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="form-submit-btn" @click="handleSearch">查询</div>
        </el-form-item>
      </el-form>
    </div>
    <TableBox class="table-box">
      <Table :table-data="tableData" @openEdit="openEdit"></Table>
    </TableBox>
    <Dialog :show-foot="false" width="700px" v-if="showAddEdit" :background-image="require('./components/add-bg.png')"
            @close="showAddEdit = false" title="编辑点位">
      <AddEdit :info="addEditForm" @close="showAddEdit = false" @confirm="confirmEdit"></AddEdit>
    </Dialog>
    <div style="text-align: center;padding-top: 10px">
      <el-pagination
        class="ai-pagination"
        popper-class="ai-pagination"
        @current-change="handleCurrentChange"
        :current-page="formInline.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formInline.limit"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import TableBox from '@/components/ClipBox/index.vue'
import Table from "./components/Table";
import AddEdit from "./components/AddEdit";
import { townshipList } from "../../../utils/common";
import { getDeviceList, editDevice } from "../../../api/device";
import Dialog from "@/components/Dialog/index"
export default {
  name: "index", // 点位管理
  components: { TableBox, Table, AddEdit, Dialog },
  data () {
    return {
      townshipList: townshipList,
      date: [],
      total: 0,
      formInline: {
        deviceName: '',
        town: '',
        status: '',
        page: 1,
        limit: 10
      },
      onLine: 0,
      offLine: 0,
      showAddEdit: false,
      addEditForm: {},
      tableData: [],
      timer: null
    }
  },
  mounted() {
    this.getList()
    this.getAllList()
    this.timer = setInterval(() => {
      this.getAllList()
    },30000)
  },
  beforeDestroy() {
    if (this.timer === null) {
      return false
    }
    clearInterval(this.timer)
  },
  methods: {
    handleSearch () {
      this.formInline.page = 1
      this.getList()
    },
    handleCurrentChange (val) {
      this.formInline.page = val
      this.getList()
    },
    getList () {
      getDeviceList(this.formInline).then(res => {
        this.tableData = res.data.list
        this.total = res.data.totalCount
      })
    },
    getAllList () {
      getDeviceList({page: 1, limit: 999}).then(res => {
        this.onLine = 0
        this.offLine = 0
        res.data.list.forEach(x => {
          if (x.status === 1) {
            this.onLine++
          } else {
            this.offLine++
          }
        })
      })
    },
    openEdit (item) {
      this.addEditForm = item
      this.showAddEdit = true
    },
    confirmEdit (item) {
      let form = JSON.parse(JSON.stringify(item))
      if (item.type === 0) {
        form.haiKangYs7 = {
          deviceSerial: form.deviceSerial
        }
      } else {
        form.daHuaYunRui = {
          deviceId: form.deviceSerial
        }
      }
      editDevice(form).then(() => {
        this.$message.success('操作成功！')
        this.getList()
      })
    }
  }
}
</script>

<style scoped lang="less">
.data-examine{
  width: 100%;
  height: 100%;
  position: relative;
  .option-box{
    position: absolute;
    display: flex;
    top: -62px;
    right: 0;
    .btn1{
      width: 126px;
      height: 42px;
      background: url("./img/btn1.png") no-repeat
        center / 100% 100%;
      font-size: 18px;
      text-align: center;
      line-height: 42px;
      font-weight: 400;
      color: #00B2FF;
      cursor: pointer;
    }
    .btn2{
      margin-left: 10px;
      width: 126px;
      height: 42px;
      background: url("./img/btn2.png") no-repeat
        center / 100% 100%;
      font-size: 18px;
      text-align: center;
      line-height: 42px;
      font-weight: 400;
      color: #FF1C2F;
      cursor: pointer;
    }
  }
  .search-box {
    padding-top: 28px;
    .form-input {
      width: 200px;
      height: 40px;
    }
    .form-select{
      /deep/ .el-input__inner{
        height: 40px;
      }
    }

    &::v-deep {
      .el-form-item__label {
        padding-right: 28px;
        font-size: 20px;
        color: #ffffff;
      }
    }
    .form-submit-btn {
      width: 150px;
      height: 50px;
      line-height: 50px;
      margin-top: -5px;
      margin-left: 25px;
      font-size: 17px;
      color: #00b2ff;
      letter-spacing: 12px;
      text-indent: 12px;
      text-align: center;
      background: url("~@/assets/img/settings/button-bg2.png") no-repeat
        center / 100% 100%;
      cursor: pointer;
    }
  }
  .table-box{
    width: 100%;
    height: calc(100% - 150px);
  }
}
/deep/ .el-input__inner {
  width: 100%;
  //height: 40px;
  font-size: 18px;
  line-height: inherit;
  font-weight: 500;
  background: rgba(0, 45, 65, 0.2);
  border: 1px solid #00B2FF;
  color: #00B2FF;
  box-shadow: 0 0 12px 4px rgba(0, 178, 255, 0.2) inset;

  &::-webkit-input-placeholder {
    color: rgba(0, 178, 255, 0.3);
  }
}
/deep/ .el-form-item__label{
  color: #FFFFFF;
  font-size: 18px;
}
</style>
